import axios from 'axios';
import API_CONFIG from '../config/api';
import { translateVi } from '../i18n/LocaleContext';

const API_URL = API_CONFIG.getApiUrl(API_CONFIG.ENDPOINTS.CHAT);

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

export const chatService = {
  // User lấy lịch sử chat của mình
  getChatHistory: async (limit = 50, offset = 0) => {
    try {
      const response = await axios.get(`${API_URL}/history?limit=${limit}&offset=${offset}`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể lấy lịch sử chat'));
    }
  },

  // Upload ảnh cho chat CSKH (dùng chung cho user và admin)
  uploadImage: async (file) => {
    try {
      const formData = new FormData();
      formData.append('image', file);

      const token = localStorage.getItem('token');
      const response = await axios.post(`${API_URL}/upload-image`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể upload ảnh'));
    }
  }
};
